import { useState, useEffect, useContext } from 'react';
import { UserContext } from '../../../helper/ProtectedRoute';
import dayjs from 'dayjs';
import { Loader2 } from 'lucide-react';

const TableComponent = ({
  tableData,
  isLoading,
}) => {
  const [state] = useContext(UserContext);
  const [role, setRole] = useState(sessionStorage.getItem('user_access_role'));
  useEffect(() => {
    setRole(state.roles);
  }, [state.roles]);

  return (
    <>
      <thead className="bg-gray-50 border-b border-gray-200">
        <tr>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">#</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Tracking Id</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Customer Reference No</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Origin Country</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Origin City</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Destination Country</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Destination City</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Billing Country</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Tier</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Product</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Billing Weight</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">COD Amount</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">COD Currency</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">COD Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">COD Converted Amt</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">COD Conversion Factor</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Freight Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">RTO Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">ODA Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Fuel Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Insurance Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Platform Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Total Charge</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Net Receivable</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">GPA Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">VAT</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">VAT Percentage</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">VAT Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Low Clearance Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">High Clearance Charges</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Clearance Conversion Factor</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Customer Billing Currency</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Conversion Factor</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Billing Currency</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Pickup Date</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Delivery Date</th>
          <th className="tbl-th sticky top-0 z-20 bg-gray-50">Status</th>
        </tr>
      </thead>
      <tbody className="divide-y divide-gray-200">
        {isLoading ? (
          <tr>
            <td colSpan={37} className="px-6 py-12 text-center text-gray-500">
              <div className="flex items-center justify-center gap-2">
                <Loader2 className="size-4 animate-spin" />
                <span>Loading...</span>
              </div>
            </td>
          </tr>
        ) : !tableData?.length ? (
          <tr>
            <td colSpan={37} className="px-6 py-12 text-center text-gray-500">No records found</td>
          </tr>
        ) : (
          tableData.map((item, index) => (
            <tr key={index} className={`hover:bg-gray-50 transition-colors ${index % 2 === 0 ? 'bg-white' : 'bg-gray-50/50'}`}>
              <td className="tbl-td">{index + 1}</td>
              <td className="tbl-td">
                <button
                  onClick={() => {
                    sessionStorage.setItem('token', state.token);
                    window.open(`/consignments/orders/${item?.trackingId}`, '_blank');
                  }}
                  className="text-blue-600 hover:text-blue-800 hover:underline bg-transparent"
                >
                  {item?.trackingId}
                </button>
              </td>
              <td className="tbl-td">{item?.customerReferenceNumber}</td>
              <td className="tbl-td">{item?.originCountry}</td>
              <td className="tbl-td">{item?.originCity}</td>
              <td className="tbl-td">{item?.destinationCountry}</td>
              <td className="tbl-td">{item?.destinationCity}</td>
              <td className="tbl-td">{item?.billingCountry}</td>
              <td className="tbl-td">{item?.tier}</td>
              <td className="tbl-td">{item?.productCode}</td>
              <td className="tbl-td">{item?.billingWeight}</td>
              <td className="tbl-td">{item?.codAmount}</td>
              <td className="tbl-td">{item?.codCurrency}</td>
              <td className="tbl-td">{item?.codCharges}</td>
              <td className="tbl-td">{item?.codConvertedAmount}</td>
              <td className="tbl-td">{item?.codConversionFactor}</td>
              <td className="tbl-td">{item?.freightCharges}</td>
              <td className="tbl-td">{item?.rtoCharges}</td>
              <td className="tbl-td">{item?.odaCharges}</td>
              <td className="tbl-td">{item?.fuelCharges}</td>
              <td className="tbl-td">{item?.insuranceCharges}</td>
              <td className="tbl-td">{item?.platformCharges}</td>
              <td className="tbl-td">{item?.totalCharge}</td>
              <td className="tbl-td">{item?.netReceivable}</td>
              <td className="tbl-td">{item?.gpaCharges}</td>
              <td className="tbl-td">{item?.vat}</td>
              <td className="tbl-td">{item?.vatPercentage}</td>
              <td className="tbl-td">{item?.vatCharges}</td>
              <td className="tbl-td">{item?.lowClearanceCharges}</td>
              <td className="tbl-td">{item?.highClearanceCharges}</td>
              <td className="tbl-td">{item?.clearanceConversionFactor}</td>
              <td className="tbl-td">{item?.customerBillingCurrency}</td>
              <td className="tbl-td">{item?.conversionFactor}</td>
              <td className="tbl-td">{item?.billingCurrency}</td>
              <td className="tbl-td">
                {item?.pickupAt ? dayjs(item?.pickupAt).format('DD MMM YYYY, hh:mm:ss A') : null}
              </td>
              <td className="tbl-td">
                {item?.deliveredAt ? dayjs(item?.deliveredAt).format('DD MMM YYYY, hh:mm:ss A') : null}
              </td>
              <td className="tbl-td">{item?.status}</td>
            </tr>
          ))
        )}
      </tbody>
    </>
  );
};

export default TableComponent;
